import type { CSSProperties } from "react";

interface SkeletonProps {
  className?: string;
  style?: CSSProperties;
}

/** パルスアニメーション付きスケルトンプレースホルダー */
export function Skeleton({ className = "", style }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded bg-gray-200 ${className}`}
      style={style}
      aria-hidden="true"
    />
  );
}

/** 座席マップ読み込み中のスケルトン */
export function SeatMapSkeleton() {
  return (
    <div className="space-y-4">
      {/* 凡例スケルトン */}
      <div className="flex gap-4">
        <Skeleton className="h-5 w-16" />
        <Skeleton className="h-5 w-16" />
        <Skeleton className="h-5 w-16" />
      </div>
      {/* マップ領域スケルトン */}
      <Skeleton className="w-full rounded-lg" style={{ aspectRatio: "16/9" }} />
    </div>
  );
}

/** 予約一覧読み込み中のスケルトン */
export function ReservationListSkeleton() {
  return (
    <div className="space-y-6">
      {/* 日付見出し */}
      <div>
        <Skeleton className="mb-3 h-5 w-40" />
        <div className="space-y-2">
          <ReservationItemSkeleton />
          <ReservationItemSkeleton />
        </div>
      </div>
      <div>
        <Skeleton className="mb-3 h-5 w-36" />
        <div className="space-y-2">
          <ReservationItemSkeleton />
        </div>
      </div>
    </div>
  );
}

/** リピート予約ルールカードのスケルトン */
export function RecurringRuleCardSkeleton() {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-4">
          <Skeleton className="h-10 w-10 rounded-full shrink-0" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-3 w-44" />
            <Skeleton className="h-3 w-36" />
          </div>
        </div>
        <Skeleton className="h-8 w-28 rounded-md" />
      </div>
    </div>
  );
}

function ReservationItemSkeleton() {
  return (
    <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-white p-4">
      <div className="flex items-center gap-4">
        <Skeleton className="h-10 w-10 rounded-full" />
        <div>
          <Skeleton className="mb-1 h-4 w-24" />
          <Skeleton className="h-3 w-36" />
        </div>
      </div>
      <Skeleton className="h-8 w-20 rounded-md" />
    </div>
  );
}
